module.exports = __webpack_public_path__ + "img/crop1.b7e9c16c.png";